export const GET_AUDIT_ACCOUNT_TYPE_LIST = '/admin/audit-transactions/account-types';
export const GET_AUDIT_ROLE_LIST = '/admin/audit-transactions/roles';
export const GET_AUDIT_ACTION_LIST = '/admin/audit-transactions/action-types';
export const POST_USER_API_AUDIT = (
  page: number | undefined,
  size: number | undefined,
  startDate: string | undefined,
  endDate: string | undefined
) =>
  `/admin/audit-transactions/search?page=${page}&size=${size}&startDate=${startDate}&endDate=${endDate}`;
export const POST_AUDIT_DOWNLOAD = (startDate: string | undefined, endDate: string | undefined) =>
  `/admin/audit-transactions/report?startDate=${startDate}&endDate=${endDate}`;
